import { createCartClient, money, escapeHtml, trackingTarget, canOrder } from 'hestura-commerce';
import { resolveRangeSelection, rangePath } from 'hestura-range';

const $ = selector => document.querySelector(selector);
const $$ = selector => [...document.querySelectorAll(selector)];
const root = document.body.dataset.root || '/';
const checkoutOpen = document.body.dataset.checkoutOpen === 'true';
const client = createCartClient(window.fetch.bind(window), root);
const copy = JSON.parse($('#hestura-copy')?.textContent || '{}');
const format = cents => money(cents, document.body.dataset.currency || 'GBP', document.body.dataset.locale || 'en-GB');
const esc = escapeHtml;
let currentCart;
let toastTimer;

const rangeData = JSON.parse($('#hestura-range-data')?.textContent || 'null');
if (rangeData) $$('[data-range-selector]').forEach(selector => {
  const params = new URLSearchParams(window.location.search);
  const initial = resolveRangeSelection(rangeData, params.get('colour'), params.get('size'));
  selector.querySelectorAll('[data-range-colour]').forEach(input => { input.checked = input.value === initial.colour.id; });
  selector.querySelectorAll('[data-range-size]').forEach(input => { input.checked = input.value === initial.size.id; });
  const update = () => {
    const selected = resolveRangeSelection(rangeData, selector.querySelector('[data-range-colour]:checked')?.value, selector.querySelector('[data-range-size]:checked')?.value);
    selector.querySelector('[data-range-summary]').textContent = `${selected.colour.name} · ${selected.size.name} · ${selected.size.dimensions}`;
    selector.querySelector('[data-range-link]').href = rangePath(root, selected);
    const gallery = $('[data-range-gallery]');
    if (gallery) {
      const hasPhoto = Boolean(selected.colour.photo);
      gallery.querySelector('[data-range-photo]').hidden = !hasPhoto;
      gallery.querySelector('[data-range-thumbs]').hidden = !hasPhoto;
      gallery.querySelector('[data-range-photo-placeholder]').hidden = hasPhoto;
      if (hasPhoto) setImage(gallery.querySelector('[data-range-photo] img'), selected.colour.photo, selected.colour.name);
      else {
        gallery.querySelector('[data-range-photo-name]').textContent = selected.colour.name;
        gallery.querySelector('[data-range-photo-swatch]').style.setProperty('--swatch', selected.colour.swatch);
      }
    }
  };
  selector.addEventListener('change', update);
  update();
});

function setImage(image, url, alt) {
  if (!image) return;
  image.removeAttribute('srcset');
  image.removeAttribute('sizes');
  image.src = url;
  if (alt) image.alt = alt;
}

function toast(message) {
  const node = $('#hestura-toast');
  if (!node) return;
  clearTimeout(toastTimer);
  node.textContent = message;
  node.hidden = false;
  toastTimer = setTimeout(() => { node.hidden = true; }, 4500);
}

function renderCart(cart) {
  currentCart = cart;
  $$('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; });
  const content = cart.items.length ? '<div class="cart-items">' + cart.items.map(item => '<article class="cart-item">' + (item.image ? '<img class="cart-item-image" src="' + esc(item.image) + '" alt="' + esc(item.product_title) + '" width="82" height="117">' : '<div></div>') + '<div><h3><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></h3><p>' + esc(item.variant_title || '') + '</p><div class="cart-item-quantity"><button type="button" data-cart-key="' + esc(item.key) + '" data-cart-delta="-1" aria-label="' + esc(copy.decrease) + '">−</button><span>' + item.quantity + '</span><button type="button" data-cart-key="' + esc(item.key) + '" data-cart-delta="1" ' + (item.quantity >= 10 ? 'disabled' : '') + ' aria-label="' + esc(copy.increase) + '">+</button><button type="button" class="remove-item" data-cart-key="' + esc(item.key) + '" data-cart-remove>' + esc(copy.remove) + '</button></div></div><span class="line-price">' + esc(format(item.final_line_price)) + '</span></article>').join('') + '</div><div class="cart-summary"><div class="summary-row"><span>' + esc(copy.subtotal) + '</span><span>' + esc(format(cart.original_total_price)) + '</span></div>' + (cart.total_discount ? '<div class="summary-row discount-row"><span>' + esc(copy.discount) + '</span><span>−' + esc(format(cart.total_discount)) + '</span></div>' : '') + '<div class="summary-row"><span>' + esc(copy.shipping) + '</span><span>' + esc(copy.shippingNote) + '</span></div><div class="summary-row total-row"><span>' + esc(copy.total) + '</span><strong>' + esc(format(cart.total_price)) + '</strong></div>' + (checkoutOpen ? '<form method="post" action="' + esc(root + 'cart') + '"><button type="submit" name="checkout" class="button primary">' + esc(copy.checkout) + ' ↗</button></form>' : '<p class="cart-disclaimer">' + esc(copy.closed) + '</p>') + '<p class="cart-disclaimer">' + esc(copy.note) + '</p><a class="continue-link" href="' + esc(root + '#collection') + '">' + esc(copy.continue) + '</a></div>' : '<div class="cart-empty"><h3>' + esc(copy.empty) + '</h3><p>' + esc(copy.emptyText) + '</p><a class="button primary" href="' + esc(root + '#collection') + '">' + esc(copy.continue) + ' ↗</a></div>';
  $$('[data-cart-content]').forEach(node => { node.innerHTML = content; node.removeAttribute('aria-busy'); });
}

async function loadCart() {
  try { renderCart(await client.read()); }
  catch { $$('[data-cart-content]').forEach(node => { node.innerHTML = '<div class="cart-empty"><p role="alert">' + esc(copy.cartError) + '</p><a class="button outline" href="' + esc(root + 'cart') + '">' + esc(copy.title) + ' ↗</a></div>'; }); }
}

async function openCart() {
  const dialog = $('#hestura-cart-dialog');
  if (!dialog?.showModal) { window.location.assign(root + 'cart'); return; }
  if (!dialog.open) dialog.showModal();
  await loadCart();
}

$$('[data-cart-open]').forEach(node => node.addEventListener('click', event => { event.preventDefault(); openCart(); }));
$$('[data-close-dialog]').forEach(node => node.addEventListener('click', () => node.closest('dialog')?.close()));
$$('dialog').forEach(dialog => dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } }));

document.addEventListener('click', async event => {
  const button = event.target.closest('[data-cart-key]');
  if (!button || !currentCart) return;
  const item = currentCart.items.find(item => item.key === button.dataset.cartKey);
  if (!item) return;
  const count = button.hasAttribute('data-cart-remove') ? 0 : item.quantity + Number(button.dataset.cartDelta);
  $$('[data-cart-key]').forEach(node => { node.disabled = true; });
  $$('[data-cart-content]').forEach(node => node.setAttribute('aria-busy', 'true'));
  try { renderCart(await client.change(item.key, count)); }
  catch (error) { toast(error.message || copy.productError); await loadCart(); }
});

const menu = $('#hestura-menu');
const toggle = $('[data-menu-toggle]');
toggle?.addEventListener('click', () => { menu.hidden = !menu.hidden; toggle.setAttribute('aria-expanded', String(!menu.hidden)); });
menu?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }));
document.addEventListener('keydown', event => { if (event.key === 'Escape' && menu && !menu.hidden) { menu.hidden = true; toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); } });

const form = $('#hestura-product-form');
if (form) {
  const variants = JSON.parse($('#hestura-variants')?.textContent || '[]');
  const state = JSON.parse($('#hestura-product-state')?.textContent || '{}');
  const picker = $('#hestura-variant');
  const button = $('#hestura-add');
  const variant = () => variants.find(item => String(item.id) === picker.value);
  const update = () => {
    const selected = variant();
    button.disabled = !canOrder(selected, { checkoutOpen, samplePending: state.samplePending });
    button.textContent = (checkoutOpen ? selected?.available && !state.samplePending ? copy.add : copy.soldOut : copy.unavailable) + ' ↗';
    if (selected) $('#hestura-product-price').textContent = format(selected.price);
    const comparison = $('#hestura-compare-price');
    if (comparison) { comparison.hidden = !(selected?.compare_at_price > selected?.price); if (!comparison.hidden) comparison.textContent = format(selected.compare_at_price); }
    const sale = $('#hestura-sale-label');
    if (sale) {
      sale.hidden = !(selected?.compare_at_price > selected?.price);
      if (!sale.hidden) sale.textContent = sale.dataset.discountLabel.replace('__PERCENT__', String(Math.round((selected.compare_at_price - selected.price) * 100 / selected.compare_at_price)));
    }
    if (selected?.featured_image?.src) setImage($('#hestura-product-image'), selected.featured_image.src, selected.featured_image.alt || selected.name);
    const url = new URL(window.location.href);
    if (selected) { url.searchParams.set('variant', selected.id); window.history.replaceState({}, '', url); }
  };
  picker.addEventListener('change', update);
  update();
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (!canOrder(variant(), { checkoutOpen, samplePending: state.samplePending })) { toast(copy.unavailable); return; }
    const status = $('#hestura-product-status');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try { renderCart(await client.add(picker.value, form.elements.quantity.value)); status.hidden = true; toast(copy.added); await openCart(); }
    catch (error) { status.textContent = error.message || copy.productError; status.hidden = false; }
    finally { button.removeAttribute('aria-busy'); update(); }
  });
}

$$('[data-product-photo]').forEach(button => button.addEventListener('click', () => { setImage($('#hestura-product-image'), button.dataset.productPhoto); }));
$$('[data-sample-photo]').forEach(button => button.addEventListener('click', () => {
  const colour = button.dataset.sampleColour;
  const input = colour && $('[data-range-selector]')?.querySelector(`[data-range-colour][value="${colour}"]`);
  if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
  else setImage(button.closest('.gallery').querySelector('.gallery-main img'), button.dataset.samplePhoto, button.getAttribute('aria-label') || '');
}));
$$('[data-enlarge]').forEach(button => button.addEventListener('click', () => { const source = button.querySelector('img'); const dialog = $('#hestura-image-dialog'); const target = dialog?.querySelector('img'); if (source && target && dialog.showModal) { target.src = source.currentSrc || source.src; target.alt = source.alt; dialog.showModal(); } }));

let track;
$('#hestura-track-form')?.addEventListener('submit', event => {
  event.preventDefault();
  const result = $('#hestura-track-result');
  result.hidden = false;
  try { track = trackingTarget($('#track-carrier').value, $('#track-reference').value); $('#hestura-track-value').textContent = track.reference; $('#hestura-track-link').href = track.url; $('#hestura-track-link').hidden = false; $('#hestura-track-copy').hidden = false; $('#hestura-track-status').textContent = copy.trackReady; }
  catch { track = undefined; $('#hestura-track-status').textContent = copy.trackInvalid; $('#hestura-track-value').textContent = ''; $('#hestura-track-link').hidden = true; $('#hestura-track-copy').hidden = true; }
});
$('#hestura-track-copy')?.addEventListener('click', async () => { if (!track) return; try { await navigator.clipboard.writeText(track.reference); $('#hestura-track-status').textContent = copy.copied; } catch { $('#hestura-track-status').textContent = copy.copyFailed; } });

if ($('[data-cart-content]') && document.body.classList.contains('template-cart')) loadCart();
